import { InstallerProfile, InstallerState } from '@/lib/types/user/installer'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

const initialState: InstallerState = {
  items: [],
  loading: false,
  error: null,
  selectedInstallerId: null
}

const installersSlice = createSlice({
  name: 'installers',
  initialState,
  reducers: {
    setInstallers(state, action: PayloadAction<InstallerProfile[]>) {
      state.items = action.payload
      state.error = null
    },
    addInstaller(state, action: PayloadAction<InstallerProfile>) {
      state.items.push(action.payload)
      state.error = null
    },
    updateInstaller(state, action: PayloadAction<InstallerProfile>) {
      const index = state.items.findIndex(item => item.userId === action.payload.userId)
      if (index !== -1) {
        state.items[index] = action.payload
      }
      state.error = null
    },
    removeInstaller(state, action: PayloadAction<string>) {
      state.items = state.items.filter(item => item.userId !== action.payload)
      state.error = null
    },
    setSelectedInstallerId(state, action: PayloadAction<string | null>) {
      state.selectedInstallerId = action.payload
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload
      state.loading = false
    }
  }
})

export const {
  setInstallers,
  addInstaller,
  updateInstaller,
  removeInstaller,
  setSelectedInstallerId,
  setLoading,
  setError
} = installersSlice.actions

export default installersSlice.reducer
